<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      梅村站<br>
站点介绍<br>
梅村站位于梅林路与梅村路交叉口西侧的梅林路中。上方为福田区公交分局，A出入口处为上梅林文体公园，C出入口为梅村食街。梅村站装修设计与梅林片区所独有梅花文化交相辉映，体现“梅村站员工梅花坚韧不拔，不屈不挠，奋勇当先自强不息的精神品质与基调。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:07	23:25	9号线	3分50秒	5分55秒<br>
文锦	06:34	23:44	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:05	23:25	9号线	4分25秒	5分55秒<br>
文锦	06:34	23:44	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:01	00:25	9号线	4分钟	5分55秒<br>
文锦	06:33	00:44	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
梅林路南侧（西）、上梅林文体公园、新世界荔园阁<br><br>
C1出入口:<br>
梅村路西侧、梅林三村<br><br>
C2出入口:<br>
梅林路南侧（东）、梅村路东侧、梅林四村、梅林阁<br><br>
D出入口:<br>
梅林路北侧（东）、深圳市公安局轨道交通分局、公安街、中康生活区<br><br>
E出入口:<br>
梅林路北侧（西）<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 梅林三村<br>
44路、60路、201路、324路、334路、M312路、M460路<br><br>
C1出入口:<br>
公交站名： 梅林三村东<br>
44路、60路、324路、M312路<br><br>
C2出入口:<br>
公交站名： 梅林阁<br>
201路、334路、B821路、M460路<br><br>
D出入口:<br>
公交站名： 梅林阁<br>
201路、334路、B821路、M312路、M460路<br><br>
E出入口:<br>
公交站名： 梅林三村<br>
44路、60路、201路、324路、334路、M312路、M460路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>